import React from 'react';
import { ScreenContainer } from '@pinwheel/origami';
import ModalHeader from '../../components/ModalHeader';
import NoResults from '../../views/MultiSupplierEligibility/NoResults';
import SingleResult from '../../views/MultiSupplierEligibility/SingleResult';
import MultipleResults from '../../views/MultiSupplierEligibility/MultipleResults';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useAppSelector } from '../../state';
import { selectMatchedPlatforms } from '../../state/slices/slice-link-api';
import useInputRequired from '../../hooks/useInputRequired';
import { selectHistory } from '../../state/history';
export default function MultiSupplierLookup() {
    var navigate = useLinkNavigate();
    var matchedPlatforms = useAppSelector(selectMatchedPlatforms);
    var history = useAppSelector(selectHistory);
    useInputRequired();
    return (React.createElement(ScreenContainer, { "data-testid": "mse-results" },
        React.createElement(ModalHeader, { onInfo: function () { return navigate('/multi-supplier-eligibility/help'); }, onBack: function () {
                // We want to back twice whenever we click back, this is to avoid going
                // back into lookup which will route us back to this screen.
                navigate(-1);
                navigate(-1);
            }, hideBackButton: 
            // If the history is less or equal to 2, that means that the session
            // started with lookup, so we hide the back button.
            history.length <= 2 }),
        matchedPlatforms.length < 1 ? (React.createElement(NoResults, null)) : matchedPlatforms.length > 1 ? (React.createElement(MultipleResults, null)) : (React.createElement(SingleResult, null))));
}
